import { Button, Icon } from '@smartgift/frontend-toolkit';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RECOGNITIONS_TAB } from '@hero/constants';
import { useSendRemindersNotification } from '@hero/hooks';
import { DetailItem, DetailGroup } from '@hero/molecules';
import { useSendRemindersRecognition } from '@hero/services/order-service';

import * as S from './style';

function RecognitionDetailShareMethodAccordion({ recognition, setActiveTab }) {
  const { send } = useSendRemindersNotification({ useSendReminder: useSendRemindersRecognition });
  const { t } = useTranslation();

  const onClickSendReminder = () => {
    send(recognition?.code);
  };

  const isReminderActive = useMemo(() => {
    const totalRecipients = recognition?.acceptanceRates?.total;
    const totalAcceptedRecipients = recognition?.acceptanceRates?.accepted;

    if (totalRecipients === 0) return false;
    if (totalAcceptedRecipients === 0) return true;

    return totalRecipients - totalAcceptedRecipients > 0;
  }, [recognition]);

  return (
    <S.Wrapper>
      <S.CardHeader>
        {recognition?.contacts?.type === 'list' && isReminderActive && (
          <>
            <Button variant="text" size="sm" onClick={onClickSendReminder}>
              <Icon name="email" />
              {t('remindRecipients')}
            </Button>
            <S.VerticalDivider />
          </>
        )}

        <Button
          variant="text"
          size="sm"
          onClick={() => window.open(recognition?.link?.preview, '_blank')}
          startIcon={<Icon name="preview" />}
        >
          {t('viewGiftPreview')}
        </Button>

        <S.VerticalDivider />

        <Button
          variant="text"
          size="sm"
          onClick={() => setActiveTab(RECOGNITIONS_TAB.shareOptions)}
          startIcon={<Icon name="upload" />}
        >
          {t('seeShareOptions')}
        </Button>
      </S.CardHeader>

      <S.Row>
        <S.Col style={{ flex: '.9' }}>
          <DetailGroup>
            <DetailItem title={`${t('sharedVia')}`} className="item-d-flex">
              <S.CapitalizedP>
                {recognition?.experienceSettings?.sharingMethod?.type === 'email'
                  ? t('email')
                  : t('link')}
              </S.CapitalizedP>
            </DetailItem>
            {recognition?.experienceSettings?.sharingMethod?.params?.subject && (
              <DetailItem title={`${t('subjectLine')}`} className="item-d-flex">
                {recognition?.experienceSettings?.sharingMethod?.params?.subject}
              </DetailItem>
            )}
          </DetailGroup>
        </S.Col>
      </S.Row>
    </S.Wrapper>
  );
}

export { RecognitionDetailShareMethodAccordion };
